import LTPlatform from "../../LTGame/Platform/LTPlatform";
import BaseUIMediator from "../../LTGame/UIExt/FGui/BaseUIMediator";
import UI_Super from "../../ui/Main/UI_Super";
import GlobalUnit from "../common/GlobalUnit";
import AudioManager from "../manager/AudioManager";
import { EPlatformType } from "../../LTGame/Platform/EPlatformType";
export class UI_SuperMediator extends BaseUIMediator {
    static get instance() {
        if (this._instance == null) {
            this._instance = new UI_SuperMediator();
            this._instance._classDefine = UI_Super;
        }
        return this._instance;
    }
    _OnShow() {
        super._OnShow();
        this.ui.m_btn_get.onClick(this, this.GetReward);
        this.ui.m_btn_close.onClick(this, this.OnClose);
        LTPlatform.instance.RecordEvent('game_ad_show', {
            level_id: GlobalUnit.game.level.config.id,
            id: 'super_pop'
        });
        if (LTPlatform.instance.platform == EPlatformType.WX) {
            LTPlatform.instance.ShowBannerAd();
        }
    }
    GetReward() {
        return __awaiter(this, void 0, void 0, function* () {
            AudioManager.instance.PlayById(1);
            let res = yield LTPlatform.instance.ShowRewardVideoAdAsync();
            if (res) {
                LTPlatform.instance.RecordEvent('game_ad', {
                    level_id: GlobalUnit.game.level.config.id,
                    id: 'super_pop'
                });
                GlobalUnit.game.player.OnSuper();
                GlobalUnit.game.level.ChangeDoorParams();
                this.Hide();
            }
        });
    }
    OnClose() {
        AudioManager.instance.PlayById(1);
        this.Hide();
    }
    _OnHide() {
        // GlobalUnit.game.StartGame();
        this._openParam && this._openParam();
    }
}
